import api from "./api";

const TransporterService = {
    // Create a new Transporter
    create: async (data) => {
        const res = await api.post("/transporters/save", data);
        return res.data;
    },

    // Get all Transporters
    getAll: async () => {
        const res = await api.get("/transporters/getAll");
        return res.data;
    },

getActiveTransporters: async (page = 1, limit = 20) => {
        const res = await api.get(`/transporters/getActive?page=${page}&limit=${limit}`);
        return res.data; // returns { data, page, limit, total, totalPages }
    },

    getTransporters: async (page = 1, limit = 20, search = "") => {
        const res = await api.get(`/transporters/get?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`);
        return res.data; // returns { data, page, limit, total, totalPages }
    },


    // // Get active Transporters
    // getActiveTransporters: async () => {
    //     const res = await api.get("/transporters/getActive");
    //     return res.data;
    // },

    // Get Transporter
    getById: async (id) => {
        const res = await api.get(`/transporters/getById/${id}`);
        return res.data;
    },

    // Update transporter
    update: async (id, data) => {
        const res = await api.put(`/transporters/updateTransporter/${id}`, data);
        return res.data;
    },

    // Update transporter status
    updateStatus: async (id) => {
        const res = await api.put(`/transporters/updateStatus/${id}`);
        return res.data;
    },




};

export default TransporterService;
